import { Injectable } from '@angular/core';
import * as Msal from 'msal';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable()
export class MsalUserService {
    private accessToken: any;
    public clientApplication: Msal.UserAgentApplication;
    constructor() {
        this.Autenticar();
    }

    public Autenticar(){
        this.clientApplication = new Msal.UserAgentApplication(
            environment.uiClienId,
            'https://login.microsoftonline.com/' + environment.tenantId,
            this.authCallback,
            {
                storeAuthStateInCookie: true,
            });
           
       const user = this.clientApplication.getUser();
        if (user != null) {
            environment.userEmailLogged = user.displayableId;
            environment.userFullname = user.name;
            sessionStorage.setItem("userEmailLogged",user.displayableId);
        }
    }

    public GetAccessToken(): Observable<any> {
        if (sessionStorage.getItem('msal.idtoken') !== undefined && sessionStorage.getItem('msal.idtoken') != null) {
            this.accessToken = sessionStorage.getItem('msal.idtoken');
        }
        return this.accessToken;
    }

    public authCallback(errorDesc, token, error, tokenType) {
        if (token) {

        } else {
            console.log(error + ':' + errorDesc);
        }
    }

    public getCurrentUserInfo() {
       return this.clientApplication.getUser();
    }
    public logout() {
       this.clientApplication.logout();
    }

    public login() {
        this.clientApplication.loginRedirect();
    }
}
